import React, {PropTypes} from "react";
import {BootstrapTable, TableHeaderColumn as TableHead} from "react-bootstrap-table";
import {OverlayTrigger, Tooltip} from "react-bootstrap";

function columnClassNameFormat(fieldValue, row, rowIdx, colIdx) {
  // fieldValue is column value
  // row is whole row object
  // rowIdx is index of row
  // colIdx is index of column
  if (row.empStatus == 'F')
    return 'blue';


  return row.empStatus == 'I' ? 'color3' : 'td-column-function-odd-example';
}

function columnClassNameStatusFormat(fieldValue, row, rowIdx, colIdx) {
  // fieldValue is column value
  // row is whole row object
  // rowIdx is index of row
  // colIdx is index of column
  return row.itStatus == 'pending' ? 'color2' : 'color4';
}

function columnClassNameVerticalHeadFormat(fieldValue, row, rowIdx, colIdx){
  return row.vhStatus == 'pending' ? 'color2' : 'color4';
}

function enumFormatter(cell, row, enumObject) {
  return enumObject[cell];
}
class ExitTable extends React.Component {

  constructor() {
    super();
    this.state = {};
    this.disableSSOAccount = this.disableSSOAccount.bind(this);
  }

  disableSSOAccount(emailId)
  {

    window.open("https://accounts.quikr.com/identity/v1/deleteUser?emailId="+emailId);
  }

  renderShowsTotal(start, to, total) {
    return (
      <p style={ {color: 'black'} }>
        From { start } to { to }, total entries { total }
      </p>
    );
  }

  checkNull(cell, row, formatExtraData, rowIdx) {
    if (cell == null || cell == undefined || cell == "") {
      return 'NA';
    }
    else return cell;
  }


  render() {
    const departmentType = {
      "Ad Sales": "Ad Sales",
      "Admin": "Admin",
      "Analytics": "Analytics",
      "Application Development": "Application Development",
      "At home beauty service": "At home beauty service",
      "Back Office": "Back Office",
      "BEAUTY": "BEAUTY",
      "Branch Sales": "Branch Sales",
      "Business Development": "Business Development",
      "Business Intelligence": "Business Intelligence",
      "C2C": "C2C",
      "Car & Bike Services": "Car & Bike Services",
      "Carnation": "Carnation",
      "CEO Office": "CEO Office",
      "Channel Partners": "Channel Partners",
      "Content Creation": "Content Creation",
      "Content Moderation": "Content Moderation",
      "Content Review": "Content Review",
      "Corporate Sales": "Corporate Sales",
      "Customer Service": "Customer Service",
      "Customer Support": "Customer Support",
      "Delivery Ops": "Delivery Ops",
      "Delivery Ops - VL": "Delivery Ops - VL",
      "Design": "Design",
      "Digital Marketing": "Digital Marketing",
      "Direct Sales": "Direct Sales",
      "Domain Research": "Domain Research",
      "Doorstep": "Doorstep",
      "Education": "Education",
      "Engineering": "Engineering",
      "Executive Assistant": "Executive Assistant",
      "FINANCE": "FINANCE",
      "Finance and Accounts": "Finance and Accounts",
      "Google Adwords": "Google Adwords",
      "Groups": "Groups",
      "HIREE": "HIREE",
      "HomeVision": "HomeVision",
      "HR": "HR",
      "Human Resource": "Human Resource",
      "Human Resources": "Human Resources",
      "Implementation": "Implementation",
      "Inspection": "Inspection",
      "IRX": "IRX",
      "IT": "IT",
      "IT Infra": "IT Infra",
      "Jobs": "Jobs",
      "Listing Operations": "Listing Operations",
      "Marketing": "Marketing",
      "MGMT": "MGMT",
      "MIS": "MIS",
      "Mobile Development": "Mobile Development",
      "Mobile Exchange": "Mobile Exchange",
      "Offline Content": "Offline Content",
      "oms": "oms",
      "On-Demand Services": "On-Demand Services",
      "online": "online",
      "operation": "operation",
      "Operations": "Operations",
      "PKHD": "PKHD",
      "PLV": "PLV",
      "Product": "Product",
      "Product Monetization": "Product Monetization",
      "Product Operations": "Product Operations",
      "Public Relations": "Public Relations",
      "QA": "QA",
      "Quality": "Quality",
      "Quikr Cars": "Quikr Cars",
      "Quikr Education": "Quikr Education",
      "Quikr Education Sales": "Quikr Education Sales",
      "Quikr Homes": "Quikr Homes",
      "QUIKR JOBS": "QUIKR JOBS",
      "Quikr Service": "Quikr Service",
      "Quikr Services": "Quikr Services",
      "Quikr Services (Groups)": "Quikr Services (Groups)",
      "quikr services (Sales)": "quikr services (Sales)",
      "Quikr X": "Quikr X",
      "Quikrjob": "Quikrjob",
      "Quirk Cars": "Quirk Cars",
      "RE Sales": "RE Sales",
      "RE-Quality": "RE-Quality",
      "Real Estate": "Real Estate",
      "Reality Redefined": "Reality Redefined",
      "Recovery": "Recovery",
      "Renewal": "Renewal",
      "Renewals": "Renewals",
      "Retail": "Retail",
      "Retention": "Retention",
      "Sales": "Sales",
      "Sales Analytics": "Sales Analytics",
      "Sales jobs": "Sales jobs",
      "Sales Operations": "Sales Operations",
      "sales qukr jobs": "sales qukr jobs",
      "Sales Support": "Sales Support",
      "Sales- Car & Bike": "Sales- Car & Bike",
      "Sales-Quikr Services": "Sales-Quikr Services",
      "SELLS": "SELLS",
      "service": "service",
      "Service Provider Operations": "Service Provider Operations",
      "Service Seeker Operations": "Service Seeker Operations",
      "Services": "Services",
      "Services sales": "Services sales",
      "Social Media": "Social Media",
      "Stylist": "Stylist",
      "System Admin": "System Admin",
      "TALLY SALES": "TALLY SALES",
      "Tech": "Tech",
      "Technology": "Technology",
      "Tele Sales": "Tele Sales",
      "Telecalling": "Telecalling",
      "TeleSales": "TeleSales",
      "Trainer": "Trainer",
      "UED": "UED",
      "Video Production": "Video Production",
      "Web Development": "Web Development"
    }

    const statusType = {
      'R': 'R',
      'I': 'I'
    };
    const toeType = {
      'Involuntary': 'Involuntary',
      'Voluntary': 'Voluntary'
    };
    const noeType = {
      'Serving': 'Serving',
      'Waived_Off': 'Waived Off',
      'Gardening': 'Gardening'
    };
    const runningStatusType = {
      'pending': 'Pending',
      'Completed': 'Completed'
    };

    const options = {
      clearSearch: true,
      sizePerPageList: [10, 20, 30, 40, 200],
      paginationShowsTotal: this.renderShowsTotal// Enable showing total text
    };

    return (
      <div>
        <BootstrapTable
          exportCSV={true}
          headerStyle={ {border: 'grey 1px solid', size: '10px'} }
          containerStyle={{paddingTop: 0}}
          data={this.props.employees}
          search={true}
          striped
          options={options}
          pagination>
          <TableHead isKey={false}
                     hidden={false}
                     columnClassName={ columnClassNameFormat }
                     width={50}
                     dataFormat={(cell, row)=> {
                       return <div>
                         <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Edit</Tooltip>}>
                           <img
                             style={{cursor: 'pointer'}}
                             onClick={()=> {
                               this.props.edit(row);
                               this.props.open();
                             }}
                             src="/public/images/edit.png"></img>
                         </OverlayTrigger>
                         <hr style={{padding: 1, margin: 1}}/>
                         <OverlayTrigger placement="top" overlay={<Tooltip id="tooltip">Disable SSO</Tooltip>}>
                           <img
                             style={{cursor: 'pointer'}}
                             onClick={()=> {
                               this.disableSSOAccount(row.emailId);

                             }}
                             src="/public/images/error.png"></img>
                         </OverlayTrigger>

                       </div>
                     }}
                     dataField="empId"> </TableHead>
          <TableHead dataSort={true}
                     isKey={true}
                     hidden={false}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Id'} }
                     width={80}
                     columnClassName={ columnClassNameFormat }
                     dataField="employeeCode">Id</TableHead>
          <TableHead dataSort={true}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Name'} }
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell, row)=> {
                       if (row.typeOfExit == 'abscond')
                         return <font>{cell}&nbsp;(*abscond)</font>
                       else
                         return <font>{cell}</font>
                     }}
                     width={140} dataField="name"
          >Name</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'EmailId'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="emailId">Email Id</TableHead>
          <TableHead dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Designation'} }
                     dataFormat={this.checkNull}
                     width={150}
                     dataField="designation">Designation</TableHead>
          <TableHead dataField="vhStatus"
                     width={100}
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'VH Status'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameVerticalHeadFormat }
          >VH Status</TableHead>
          <TableHead dataField="itStatus"
                     width={100}
                     filter={ {type: 'SelectFilter', options: runningStatusType, placeholder: 'ItStatus'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameStatusFormat }
          >ItStatus</TableHead>

          <TableHead dataField="itComments"
                     width={150}

                     dataFormat={this.checkNull}
                     dataSort={true}

          >Remarks</TableHead>


          <TableHead dataField="doLeaving"

                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Last Working Day'} }
                     columnClassName={ columnClassNameFormat }
                     dataFormat={(cell)=> {
                       if (cell != null && cell != " " && cell != 0)
                         return <font>{cell}</font>
                       else
                         return 'NA';
                     }}
                     dataSort={true}
                     width={130}>Last Working Day</TableHead>
          <TableHead dataField="reportingTo"
                     columnClassName={ columnClassNameFormat }
                     width={80}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Mgr Id'} }
          >ManagerId</TableHead>

          <TableHead dataField="managerName"
                     columnClassName={ columnClassNameFormat }
                     width={100}
                     filter={ {type: 'TextFilter', delay: 0, placeholder: 'Mgr Name'} }
                     >Manager</TableHead>


          <TableHead dataField="location"
                     filter={ {type: 'SelectFilter', options: this.props.constants.locationFilter, placeholder: 'Location'} }
                     dataFormat={this.checkNull}
                     dataSort={true}
                     columnClassName={ columnClassNameFormat }
                     width={100}>Location</TableHead>

        </BootstrapTable>

      </div>
    );
  }
}

ExitTable.propTypes = {};

export default ExitTable;





/** WEBPACK FOOTER **
 ** ./src/feature/it/Exit/ItExitTable.js
 **/